import React, { useContext } from 'react';
import { ReactComponent as FB } from './facebook.svg';
import { ReactComponent as GGL } from './google.svg';
import './Login.scss';
import { Context } from '../@context/Context';
import fetch from '../@helper/fetch/fetch';
import { saveSession, toParam } from '../@helper/common/common.js';
import { isBrowser } from "react-device-detect";

const renderAuth = (auth, logout) => {
    if (auth.account === 'email') {
        return (
            <div>
                <div className="login__auth">
                    <p className="login__auth-text">Joined via Email</p>
                    <p className="login__auth-number">{auth.data.email}</p>
                </div>
                <button className="login__auth__logout" onClick={logout}>Log Out and try again</button>
            </div>
        );
    }
    if (auth.account === 'facebook') {
        return (
            <div>
                <div className="login__auth">
                    <p className="login__auth-text">Joined via</p>
                    <FB className="login__auth-btn login__auth-btn-fb" />
                    <p className="login__auth-number">{auth.data.name}</p>
                </div>
                <button className="login__auth__logout" onClick={logout}>Log Out and try again</button>
            </div >
        );
    }
    if (auth.account === 'google') {
        return (
            <div>
                <div className="login__auth">
                    <p className="login__auth-text">Joined via</p>
                    <GGL className="login__auth-btn" />
                    <p className="login__auth-number">{auth.data.name}</p>
                </div>
                <button className="login__auth__logout" onClick={logout}>Log Out and try again</button>
            </div>
        );
    }

};

// const loginPhonne = (phone, setAuthorized, setPhone, setError) => () => {
//     const disabled = phone.length < 5;
//     if (disabled) {
//         setError({ text: 'Please enter a valid phone number', type: 'accountKit', show: true, body: '' });
//         return;
//     }
//
//     const phoneNumber = parsePhoneNumberFromString(`Phone: ${phone}`);
//     window.AccountKit.login(
//         'PHONE',
//         {
//             countryCode: `+${phoneNumber.countryCallingCode}`,
//             phoneNumber: phoneNumber.nationalNumber
//         },
//         (response) => {
//             if (response.status === 'PARTIALLY_AUTHENTICATED') {
//                 const params = {
//                     code: response.code
//                 };
//                 fetch.post('/authorize_account_kit', params)
//                     .then(({ data: { access_token } }) => {
//                         saveSession('accessToken', access_token);
//                         setAuthorized(true);
//
//                     }).catch((e) => {
//                         setError({ text: 'Authentication error', type: 'accountKit', show: true, body: e });
//                     });
//             } else {
//                 setPhone('');
//                 setError({ text: 'Authentication error', type: 'accountKit', show: true, body: null });
//             }
//         }
//     );
// };

const socAuthorize = (params, setAuthorized, setError) => {
    const url = '/authorize_social_via_access_token' + toParam(params)
    return fetch.get(url)
        .then(({ data: { access_token } }) => {
            saveSession('accessToken', access_token);
            setAuthorized(true);
        })
        .catch((e) => {
            setError({ text: 'Authentication error', type: 'authorize', show: true, body: e });
        });
};

const loginFB = (setAuthorized, setError) => () => {
    window.FB.login((res) => {
        if (res.status === 'connected') {
            const params = {
                access_token: res.authResponse.accessToken,
                driver: 'facebook'
            };
            return socAuthorize(params, setAuthorized, setError);
        }
        setError({ text: 'Authentication error', type: 'facebook', show: true, body: null });
    }, { scope: 'email' });
};

const loginGGL = (setAuthorized, setError) => () => {
    window.GoogleAuth.signIn()
        .then(gglRes => {
            const res = gglRes.getAuthResponse();

            const params = {
                access_token: res.access_token,
                driver: 'google'
            };
            socAuthorize(params, setAuthorized, setError);
        }).catch(e => {
            setError({ text: 'Authentication error', type: 'google', show: true, body: e });
        });
};


const Login = (props) => {

    const loginErr = !window.sessionStorage.getItem('accessToken');

    const {
        state: {
            email,
            cardName,
            name,
            auth,
            error,
        },
        actions: {
            setEmail,
            setError,
            setAuthorized,
            logout
        }
    } = useContext(Context);

    const loginEmail = (email, setAuthorized, setError) => () => {
        const url = '/signup';
        const errorText = cardName ? 'Authentication error' : 'Please fill out the payment details';
        const params = {
            registration_source: 'email',
            name: cardName,
            email: email,
        };
        fetch.post(url, params).then(({ data: { access_token } }) => {
            saveSession('accessToken', access_token);
            setAuthorized(true);
        }).catch((e) => {
            setError({ text: errorText, type: 'authorize', show: true, body: e });
        });
    };

    function handleEmailChange(evt) {
        setEmail(evt.target.value);
    }

    let styleEmailAuth = 'login__form-input';
    let styleFBAuth = 'login__soc-auth__btn login__soc-auth__btn-fb';
    let styleGGLAuth = 'login__soc-auth__btn login__soc-auth__btn-ggl';


    if (error.type === 'braintree' && loginErr) {
        styleEmailAuth = styleEmailAuth + ' err';
        styleFBAuth = styleFBAuth + ' err';
        styleGGLAuth = styleGGLAuth + ' err';
    }

    if (error.type === 'accountKit') {
        styleEmailAuth = styleEmailAuth + ' err';
    }
    if (error.type === 'google') {
        styleGGLAuth = styleGGLAuth + ' err';
    }
    if (error.type === 'facebook') {
        styleFBAuth = styleFBAuth + ' err';
    }

    return (
        <div className="container container_center">
            {auth.account ? renderAuth(auth, logout) : (<div>
                    <p className="login__title">Join or Sign In via:</p>
                    <div className="login__options">
                        <div className="login__form">
                            <input
                                type="email" name="email" autoComplete="email" value={email} className={styleEmailAuth} onChange={handleEmailChange}
                                placeholder={'Email'}
                            />
                            <button className="login__form-btn" onClick={loginEmail(email, setAuthorized, setError)}>
                                Apply
                            </button>
                        </div>
                        <div className="login__options-soc">
                            <p className="login__separator">{isBrowser ? 'or' : 'Or continue with'}</p>
                            <div className="login__soc-auth">
                                <button className={styleFBAuth} onClick={loginFB(setAuthorized, setError)}>
                                    <FB />
                                </button>
                                <button className={styleGGLAuth} onClick={loginGGL(setAuthorized, setError)}>
                                    <GGL />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                )}
        </div>
    );
};

export default Login;